export default __webpack_public_path__ + "static/media/sub-category-coworking-Classroom.9bc761e4.jpg";